/** @format */

import React, { Component } from 'react';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import Error from '@material-ui/icons/ErrorOutline';
import CustomInput from '../../components/CustomInput/CustomInputExt';

import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

class TextAreaFormRest extends Component {
    render() {
        const {
            classes,
            callback,
            disabled,
            stateName,
            stateObjectState,
            typeCallback,
            typeField,
            displayFieldName,
            displayFieldValue,
            vMax,
            vMin,
            required,
            additionalContent,
            ...rest
        } = this.props;
        return (
            <CustomInput
                {...rest}
                success={stateName === FormGeneralHelper.SUCCESS}
                error={stateName === FormGeneralHelper.ERROR}
                labelText={displayFieldName}
                labelTextValue={displayFieldValue}
                additionalContent={additionalContent}
                id={stateName}
                formControlProps={{
                    fullWidth: true,
                }}
                required={required}
                inputProps={{
                    onChange: (event) => callback(event, stateName, typeCallback, required, vMax, vMin),
                    type: typeField,
                    disabled: disabled || false,
                    endAdornment:
                        stateObjectState === FormGeneralHelper.ERROR ? (
                            <InputAdornment position="end">
                                <Error className={classes.danger} />
                            </InputAdornment>
                        ) : (
                            undefined
                        ),
                }}
            />
        );
    }
}

TextAreaFormRest.propTypes = {
    classes: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired,
    stateName: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    stateObjectState: PropTypes.string,
    typeCallback: PropTypes.string.isRequired,
    typeField: PropTypes.string.isRequired,
    displayFieldName: PropTypes.string.isRequired,
    displayFieldValue: PropTypes.object,
    additionalContent: PropTypes.any,
    required: PropTypes.bool.isRequired,
    vMax: PropTypes.number.isRequired,
    vMin: PropTypes.number,
    value: PropTypes.any,
};

export default withStyles(oplAppStyle)(TextAreaFormRest);
